var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-label',{attrs:{"color":_vm.color,"text":_vm.text,"block":_vm.block,"small":_vm.small}})}
var staticRenderFns = []

export { render, staticRenderFns }